//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ClassFunc = require('@/tbs/util/ClassFunc')
const ObjectFunc = require('@/tbs/util/ObjectFunc')
const DateTimeFunc = require('@/tbs/util/DateTimeFunc')

/**
 * The DataConvertor class works as the rule-driven data transformer.
 * It could transform the source data to the target data and vice verse.
 */
const tbs_core_DataConvertor = function () {
    // console.log('tbs_util_Convertor constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_core_DataConvertor.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Get the data source wrapper for the scene view.
     * @param The transform object
     * @param The isArrayType flag
     * @return The wrapper name
     */
    wrapper: function (transformObject, isArrayType) {
        return transformObject.name + (isArrayType ? 'List' : '')
    },
    /**
     * @api
     * Transform the raw data into the ripe data.
     * @param The transform object
     * @param The raw data object
     * @param The isReverse flag
     */
    transform: function (transformObject, rawData, type, options) {
        // console.log('transform', transformObject, rawData, type)
        return this.doTransform(transformObject, transformObject.view[type].basePath, transformObject.view[type].rule, rawData, type, options)
    },
    queryTransform: function (transformObject, parameters, type, options) {
        return this.doQueryTransform(transformObject, parameters, type, options)
    },

    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    /**
     * @private
     * Transform the data.
     */
    doTransform: function (transformObject, basePath, rule, rawData, type, options, transformedCollection) {
        let ripeData = {}
        let pathArr = []
        // fix the rawData according to the basePath
        if (basePath) {
            pathArr = basePath.split(".")
        }
        if (pathArr.length > 0) {
            for (let i = 0; i < pathArr.length; i++) {
                rawData = rawData[pathArr[i]]
            }
        }
        rule = rule || {}
        if (ObjectFunc.isEmpty(rule)) {
            // clone the raw data as the ripe data
            ripeData = ObjectFunc.cloneObject(rawData)
        }
        else {
            if (ClassFunc.getClass(rawData) === 'Object') {
                for (let p in rule) {
                    // transform the property according to the rule
                    this.transformPropertyByRule(transformObject, p, rule[p], ripeData, rawData, type, options, transformedCollection)
                }
            }
            else if (ClassFunc.getClass(rawData) === 'Array') {
                ripeData = []
                for (let i = 0; i < rawData.length; i++) {
                    let ripeItemData = {}
                    for (let p in rule) {
                        this.transformPropertyByRule(transformObject, p, rule[p], ripeItemData, rawData[i], type, options, transformedCollection)
                    }
                    ripeData.push(ripeItemData)
                }
            }
        }
        return ripeData
    },
    doQueryTransform: function (transformObject, parameters, type, options) {
        // console.log('doQueryTransform', transformObject, parameters, type, options)
        const viewMethod = transformObject.view[type]
        if (ClassFunc.getClass(viewMethod) === 'Object') {
            parameters = parameters || {}
            const query = transformObject.view[type].query
            if (query && parameters) {
                let ripeData = {}
                for (let q in query) {
                    this.transformPropertyByRule(transformObject, q, query[q], ripeData, parameters, type, options)
                }
                return ripeData
            }
        }
        else if (ClassFunc.getClass(viewMethod) === 'Array') {
            parameters = parameters || []
            let ripeArrData = []
            for (let i = 0; i < viewMethod.length; i++) {
                let item = viewMethod[i]
                let query = item.query
                if (query && parameters) {
                    let ripeData = {}
                    for (let q in query) {
                        this.transformPropertyByRule(transformObject, q, query[q], ripeData, parameters, type, options)
                    }
                    ripeArrData.push(ripeData)
                }
            }
            if (ripeArrData.length > 0) {
                return ripeArrData
            }
        }

        return parameters
    },
    /**
     * @private
     * Transform the property by rule.
     */
    transformPropertyByRule: function (transformObject, rulePropertyName, rulePropertyValue, ripeData, rawData, type, options, transformedCollection) {
        if (rulePropertyValue.startsWith('$')) {
            let funcPrefix = 'format'
            if (type == 'query' || type == 'get' || type == 'manage') {
                funcPrefix = 'render'
            }
            // consider to introduct the method into the config
            // use the get with render and others with format
            const method = transformObject.view[type].method
            if (method && method.toUpperCase() == 'GET') {
                funcPrefix = 'render'
            }
            const argNames = rulePropertyValue.substr(1).split(',')
            let argValues = []
            for (let i = 0; i < argNames.length; i++) {
                argValues.push(ObjectFunc.getObjectPropertyByPath(rawData, argNames[i]))
            }
            argValues.push(options)
            transformedCollection && argValues.push(transformedCollection)
            const func = funcPrefix + ObjectFunc.capitalizeFirstLetter(rulePropertyName)
            ripeData[rulePropertyName] = ClassFunc.applyFunctionOnLibrary(transformObject, func, argValues)
        }
        else if (rulePropertyValue.startsWith('(') && rulePropertyValue.endsWith(')')) {
            ripeData[rulePropertyName] = rulePropertyValue.substr(1, rulePropertyValue.length - 2)
        }
        else if (rulePropertyValue.startsWith('~') && rulePropertyValue.length > 1) {
            const rawProp = rulePropertyValue.substr(1)
            if (ObjectFunc.hasObjectPropertyByPath(rawData, rawProp)) {
                ripeData[rulePropertyName] = ObjectFunc.getObjectPropertyByPath(rawData, rawProp).toString()
            }
            else {
                ripeData[rulePropertyName] = ''
            }
        }
        else if (rulePropertyValue.startsWith('#') && rulePropertyValue.length > 1) {
            const rawProp = rulePropertyValue.substr(1)
            if (ObjectFunc.hasObjectPropertyByPath(rawData, rawProp)) {
                ripeData[rulePropertyName] = Number(ObjectFunc.getObjectPropertyByPath(rawData, rawProp))
            }
            else {
                ripeData[rulePropertyName] = 0
            }
        }
        else if (rulePropertyValue.startsWith('@') && rulePropertyValue.length > 1) {
            const rawProp = rulePropertyValue.substr(1)
            if (ObjectFunc.hasObjectPropertyByPath(rawData, rawProp)
                && ObjectFunc.getObjectPropertyByPath(rawData, rawProp)) {
                ripeData[rulePropertyName] = true
            }
            else {
                ripeData[rulePropertyName] = false
            }
        }
        else if (rulePropertyValue == '@updateTime') {
            ripeData[rulePropertyName] = DateTimeFunc.getUTCTime()
        }
        else if (rulePropertyValue == '@createTime') {
            if (type == 'create') {
                ripeData[rulePropertyName] = DateTimeFunc.getUTCTime()
            }
        }
        else if (rulePropertyValue.startsWith('@random')) {
            const maxNum = Number(rulePropertyValue.replace('@random', ''))
            ripeData[rulePropertyName] = Math.round(Math.random() * maxNum).toString()
        }
        else if (rulePropertyValue.startsWith('^')) {
            ripeData[rulePropertyName] = rulePropertyValue
        }
        else {
            // console.log('@@hasObjectProperty', rulePropertyValue, ObjectFunc.hasObjectPropertyByPath(rawData, rulePropertyValue))
            if (ObjectFunc.hasObjectPropertyByPath(rawData, rulePropertyValue)) {
                ripeData[rulePropertyName] = ObjectFunc.getObjectPropertyByPath(rawData, rulePropertyValue)
            }
        }
        return ripeData
    }
}

/**
 * The static implementation approach
 * @return The static method.
*/
let instance
if (!instance) {
    instance = new tbs_core_DataConvertor
}

module.exports = instance